import { useEffect, useState } from "react"
import Table from "../../components/Table/Table"
import {
  GridCallbackDetails,
  GridColDef,
  GridRowsProp,
  GridSortModel,
} from "@mui/x-data-grid"
import { ListCustomer } from "../../models/customer.model"
import { CustomerStatusChip } from "./CustomerStatusChip"

interface CustomerTableProps {
  customers: ListCustomer[]
  isLoading: boolean
  pageInfo: any
  paginationModel: any
  setPaginationModel: React.Dispatch<React.SetStateAction<any>>
  sortModel?: GridSortModel | undefined
  onSortModelChange?:
    | ((model: GridSortModel, details: GridCallbackDetails) => void)
    | undefined
}

export const CustomerTable = ({
  customers,
  isLoading,
  pageInfo,
  paginationModel,
  setPaginationModel,
  sortModel,
  onSortModelChange,
}: CustomerTableProps) => {
  const [rowCountState, setRowCountState] = useState(
    pageInfo?.totalRowCount || 0,
  )

  useEffect(() => {
    setRowCountState((prevRowCountState: number) =>
      pageInfo?.totalRowCount !== undefined
        ? pageInfo?.totalRowCount
        : prevRowCountState,
    )
  }, [pageInfo?.totalRowCount, setRowCountState])

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "Customer ID",
      minWidth: 120,
      sortable: false,
    },
    {
      field: "customerName",
      headerName: "Customer Name",
      minWidth: 180,
      flex: 1,
      sortable: false,
    },
    {
      field: "company",
      headerName: "Company",
      minWidth: 180,
      flex: 1,
      sortable: false,
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 220,
      flex: 1,
      sortable: false,
    },
    {
      field: "panNo",
      headerName: "PAN No",
      minWidth: 140,
      sortable: false,
    },
    {
      field: "centreName",
      headerName: "Centre Name",
      minWidth: 180,
      flex: 1,
      sortable: false,
    },

    {
      field: "hasDeductedTds",
      headerName: "TDS Deducted",
      type: "boolean",
      minWidth: 150,
      sortable: false,
    },
    {
      field: "tds",
      headerName: "TDS (%)",
      minWidth: 100,
      sortable: false,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 130,
      sortable: false,
      renderCell: ({ row }) => {
        return <CustomerStatusChip row={row} />
      },
    },
    {
      field: "source",
      headerName: "Source",
      minWidth: 130,
      sortable: false,
    },
    {
      field: "code",
      headerName: "Code",
      minWidth: 120,
      sortable: false,
    },
  ]

  const rows: GridRowsProp = customers?.map((customer, index) => ({
    centreCode: customer.centreCode || "-",
    centreName: customer.centreName || "-",
    code: customer.code || "-",
    company: customer.company,
    customerName: customer.name,
    email: customer.email,
    hasDeductedTds: customer.hasDeductedTds,
    id: customer.customerId,
    isEscrowAccountPayments: customer.isEscrowAccountPayments,
    isInternationalPayments: customer.isInternationalPayments,
    panNo: customer.panNo || "-",
    rowIndex: index,
    source: customer.source,
    status: customer.status,
    tds: customer.tds,
  }))

  const columnVisibilityModel = {
    id: false,
    branch: false,
    balance: false,
    valueDate: false,
    paymentId: false,
  }

  return (
    <>
      <Table
        rows={rows}
        columns={columns}
        loading={isLoading}
        rowCount={rowCountState}
        pageSizeOptions={[10, 25, 50, 100]}
        paginationModel={paginationModel}
        paginationMode="server"
        onPaginationModelChange={setPaginationModel}
        disableColumnFilter
        columnVisibilityModel={columnVisibilityModel}
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        disableRowSelectionOnClick
      />
    </>
  )
}
